import { AreaGate } from './../../components/visit-overview/dialog/register-entrance/model/areaGate';
import { Check } from './../../components/visit-overview/dialog/register-entrance/model/Check';
import { TransportDetailLayout } from './../../common/configuration/transport.configuration';
import { Transport } from './../../common/model/transport.model';
import { SupplementaryEquipment } from '@sdbn/common';

export class RegisterEntranceLeaveData {

  transport: Transport;
  direction: 'entrance' | 'leave';

  readOnlyDetailsDefault: TransportDetailLayout;
  readOnlyDetailsMobile: TransportDetailLayout;
  editingDetailsDefault: TransportDetailLayout;
  editingDetailsMobile: TransportDetailLayout;

  areaGates: Array<AreaGate>
  tasks: Array<EntranceLeaveTask>;
  supplementaryEquipments: Array<SupplementaryEquipment>;
  outhandedSupplementaryEquipments: Array<OuthandedSupplementaryEquipment>;
  checks: Array<Check>

  weighingUsage: string;
  autoWeightSource: string;

  constructor(data?: Partial<RegisterEntranceLeaveData>) {
    if (data != null) {
      this.transport = data.transport;
      this.direction = data.direction;
      this.readOnlyDetailsDefault = data.readOnlyDetailsDefault;
      this.readOnlyDetailsMobile = data.readOnlyDetailsMobile;
      this.editingDetailsDefault = data.editingDetailsDefault;
      this.editingDetailsMobile = data.editingDetailsMobile;
      this.areaGates = data.areaGates || [];
      this.tasks = data.tasks || [];
      this.supplementaryEquipments = data.supplementaryEquipments || [];
      this.outhandedSupplementaryEquipments = data.outhandedSupplementaryEquipments;
      this.checks = data.checks || [];
      this.weighingUsage = data.weighingUsage;
      this.autoWeightSource = data.autoWeightSource;
    }
  }

}

export class AreaGateSight {

  id: number;
  name: string;

  constructor(entrance?: Partial<AreaGateSight>) {
    if (entrance != null) {
      this.id = entrance.id;
      this.name = entrance.name;
    }
  }

}

// export class SupplementaryEquipmentUsage {

//   key: string;
//   selected: boolean;
//   parameter1: any;

//   constructor(usage?: Partial<SupplementaryEquipmentUsage>) {
//     if (usage != null) {
//       this.key = usage.key;
//       this.selected = usage.selected;
//       this.parameter1 = usage.parameter1;
//     }
//   }
// }

export class HintSight {

  nameDictionaryKey: string;
  descriptionDictionaryKey: string;

  constructor(hint?: Partial<HintSight>) {
    if (hint != null) {
      this.nameDictionaryKey = hint.nameDictionaryKey;
      this.descriptionDictionaryKey = hint.descriptionDictionaryKey;
    }
  }


}

export class EntranceLeaveTask {

  id: number;
  taskId: number;
  documentTemplateId: number;
  done: boolean;
  processingHint: string;
  type: string;
  documentIds = new Array<number>();
  resourceIds = new Array<string>();

  constructor(task?: Partial<EntranceLeaveTask>) {
    if (task != null) {
      this.id = task.id;
      this.taskId = task.taskId;
      this.documentTemplateId = task.documentTemplateId;
      this.done = task.done;
      this.processingHint = task.processingHint;
      this.type = task.type;
      if (task.documentIds != null) {
        this.documentIds = task.documentIds;
      }
      if (task.resourceIds != null) {
        console.log('setting task resourceIds', task.resourceIds);
        this.resourceIds = task.resourceIds;
      }
    }
  }

}

export class WeighingResult {

  weight: number;
  source: string;
  usage: string;

  constructor(result?: Partial<WeighingResult>) {
    if (result != null) {
      this.weight = result.weight;
      this.source = result.source;
      this.usage = result.usage;
    }
  }

}

export class EntranceResult {

  nonUniqueSupplementaryEquipment: boolean;
  notes: string[];

}

export class LeaveResult {

}

export class SupplementaryEquipmentSelection {

  noHandout: boolean;
  items = new Array<SupplementaryEquipmentSelectionItem>();

  constructor(selection?: Partial<SupplementaryEquipmentSelection>) {
    if (selection != null) {
      this.noHandout = selection.noHandout;
      if (selection.items != null) {
        for (let item of selection.items) {
          this.items.push(new SupplementaryEquipmentSelectionItem(item));
        }
      }
    }
  }

}

export class SupplementaryEquipmentSelectionItem {

  checked: boolean;
  key: string;
  supplementaryEquipmentId: number;
  parameter1: any;

  constructor(item?: Partial<SupplementaryEquipmentSelectionItem>) {
    if (item != null) {
      this.key = item.key;
      this.supplementaryEquipmentId = item.supplementaryEquipmentId;
      this.parameter1 = item.parameter1;
      this.checked = item.checked;
    }
  }

}

export class OuthandedSupplementaryEquipment {
  key: string;
  dictionaryKey: string;
  selected: boolean;
  identifier: string;
  parameter1DictionaryKey: string;
  parameter1Value: string;

  constructor(equipment?: Partial<OuthandedSupplementaryEquipment>) {
    if (equipment != null) {
      this.key = equipment.key;
      this.dictionaryKey = equipment.dictionaryKey;
      this.selected = equipment.selected;
      this.identifier = equipment.identifier;
      this.parameter1DictionaryKey = equipment.parameter1DictionaryKey;
      this.parameter1Value = equipment.parameter1Value;
    }
  }
}

export class DeviceProperty {

  deviceId: string;
  deviceType: string;
  key: string;
  value: string;

  constructor(property?: Partial<DeviceProperty>) {
    if (property != null) {
      this.deviceId = property.deviceId;
      this.deviceType = property.deviceType;
      this.key = property.key;
      this.value = property.value;
    }
  }


}
